import NiceModal from '@ebay/nice-modal-react';
import { UnifiedLoginGuard } from '@turiya/login-component';
import React, { useEffect } from 'react';
import { NotificationContainer } from 'react-notifications';
import { Environments, UNIFIED_AUTH_CLIENT_ID } from './common/env';
import { getEnvironment, useDataState } from './common/state';
import { HeaderLoadingBar } from './components/HeaderLoadingBar';
import { Loading } from './components/Loading';
import { ContextHandler } from './components/auth/ContextHandler';
import { LoginScreen } from './components/auth/LoginScreen';
import Orchestrator from './components/orchestrator/Orchestrator';
import { RendererContextProvider } from '@turiya/orchestrator-renderer-react';

const AppContainer: React.FC = () => {
    const { setEnv } = useDataState();
    const environment = useDataState(getEnvironment);

    useEffect(() => {
        fetch('/env')
            .then((response) => response.text())
            .then((env) => setEnv(env as Environments));
    }, [setEnv]);

    return (
        <>
            <HeaderLoadingBar />
            <UnifiedLoginGuard
                clientId={UNIFIED_AUTH_CLIENT_ID}
                baseUrl={environment.authBaseUrl}
                loginScreenOverrides={{
                    loading: (): JSX.Element => <Loading />,
                    contextHandler: (): JSX.Element => <ContextHandler />,
                    userLogin: (props): JSX.Element => <LoginScreen {...props} />,
                }}>
                <RendererContextProvider>
                    <NiceModal.Provider>
                        <Orchestrator />
                    </NiceModal.Provider>
                </RendererContextProvider>
            </UnifiedLoginGuard>
            <NotificationContainer />
        </>
    );
};

export default AppContainer;
